<script>
import { manageStoreMethods } from "@state/helpers";
import localDatatable from "@/src/components/local-datatable.vue";
import Multiselect from "vue-multiselect";

export default {
    name: 'ItemsModal',
    props: {
        activeStore: {
            type: Object,
            required: false,
            default: () => {},
        },
        selectedTag: {
            type: Object,
            required: false,
            default: () => {}
        },
        activeItem: {
            type: Object,
            required: false,
            default: () => {}
        },
        activeAccessPoint: {
            type: Object,
            required: false,
            default: () => {}
        },
        availableTags: {
            type: Array,
            required: false,
            default: () => []
        },
        closeModal: {
            type: Function,
            required: true
        },
        action: {
            type: String,
            required: true,
            default: '',
        }
    },
    components: { 
        Multiselect,
        localDatatable
    },
    data() {
        return {
            newTag: {},
            newItem: {
                ean: null,
                description1: null,
                description2: null,
                price1: null,
                price2: null,
                discount1: null,
                discount2: null,
                sku: null,
                und: null,
                labels: [],
                store_id: null
            },
            fields: [
                { key: "ean", label: "fields.ean", size: 6, type: 'text', validations: { required: true, numeric: true } },
                { key: "description1", label: "fields.description1", size: 12, type: 'text', validations: { required: true } },
                { key: "description2", label: "fields.description2", size: 12, type: 'text', validations: { required: false } },
                { key: "price1", label: "fields.price1", size: 3, type: 'number', validations: { required: true, min_value: 0, numeric: true } },
                { key: "price2", label: "fields.price2", size: 3, type: 'number', validations: { required: false, min_value: 0, numeric: true } },
                { key: "discount1", label: "fields.discount1", size: 3, type: 'number', validations: { required: false, numeric: true, min_value: 0, max_value: 100 } },
                { key: "discount2", label: "fields.discount2", size: 3, type: 'number', validations: { required: false, numeric: true, min_value: 0, max_value: 100 } },
                { key: "sku", label: "fields.sku", size: 3, type: 'text', validations: { required: true } },
                { key: "und", label: "fields.und", size: 3, type: 'text', validations: { required: true, min: 1 } },
                { key: "labels", label: "fields.labels", size: 12, type: 'multiselect', validations: { required: false }, options: this.availableTags },
            ],
            selectedItem: {},
            items: [],
            filtered_items: [],
            isSubmitting: false,
            isModalVisible: true,
            assignModalShow: false,
            createModalShow: false,
            randomId: Math.random(),
            uploadFile: null,
            previewData: null,
            previewDataTable: {}
        }
    },
    watch: {
        activeStore: 'refreshTable',
        openModal: 'setOpenModal',
    },
    methods: {
        ...manageStoreMethods,
        clearItem(){
            this.newItem = {
                ean: null,
                description1: null,
                description2: null,
                price1: null,
                price2: null,
                discount1: null,
                discount2: null,
                sku: null,
                und: null,
                labels: [],
                store_id: null
            }
        },
        async refreshTable(){
            if (!this.activeStore || !this.selectedTag) return false
            await this.getItems()
        },
        async getItems(){
            this.isSubmitting = true
            await this.fetchItems({ store_id: this.activeStore._id }).then((response) => {
                this.items = _.cloneDeep(response.data.results);
                if (!this.selectedTag){
                    this.isSubmitting = false;
                    return true;
                } 
                const index = this.items.findIndex(x => x.ean === this.selectedTag.item_id)
                if (index > -1){
                    this.selectedItem = _.cloneDeep(this.items[index])
                    this.items[index]['is_active'] = true;
                }
                this.filtered_items = _.cloneDeep(this.items);
                this.isSubmitting = false
            })
        },
        filterUnassignedItems(){
            this.filtered_items = _.cloneDeep(this.items.filter(x => x.labels.length === 0))
        },
        filterAssignedItems(){
            this.filtered_items = _.cloneDeep(this.items.filter(x => x.labels.length > 0))
        },
        filterAllItems(){
            this.filtered_items = _.cloneDeep(this.items);
        },
        _assignItem(){
            const itemId = this.selectedItem._id
            const labelId = this.selectedTag._id
            if (this.selectedItem.is_active === false){
                this.itemId = null
            }
            this.updateLabelSetItem({ itemId, labelId }).then((resp) => {
                this.$generate_toast(
                    this,
                    'success',
                    `${this.$t('fields.label')} ${this.$t('basic.updated2')} ${this.$t('basic.correctly')}`
                    )
                this.closeModal('true'); 
            }).catch(e => {
                console.error(e)
                this.$generate_toast(
                    this,
                    'error',
                    `${this.$t('fields.label')} no ${this.$t('basic.updated2')} ${this.$t('basic.correctly')}`
                )
            })
        },
        _createUpdateItem(){
            this.newItem.store_id = this.activeStore._id
            if (this.newItem.labels.length > 0){
                this.newItem.labels = this.newItem.labels.map(x => x.id)
            }
            if (this.newItem._id){
                // edit
                this.updateItem(this.newItem).then((resp) => {
                    this.$generate_toast(
                        this,
                        'success',
                        `${this.$t('fields.item')} ${this.$t('basic.updated')} ${this.$t('basic.correctly')}`
                        )
                    this.closeModal('true'); 
                }).catch(e => {
                    console.error(e)
                    this.$generate_toast(
                        this,
                        'error',
                        `${this.$t('fields.item')} no ${this.$t('basic.updated')} ${this.$t('basic.correctly')}`
                    )
                })
            } else {
                // new (create)
                this.createItem( this.newItem ).then((resp) => {
                    this.$generate_toast(
                        this,
                        'success',
                        `${this.$t('fields.item')} ${this.$t('basic.added')} ${this.$t('basic.correctly')}`
                        )
                    this.closeModal('true'); 
                }).catch(e => {
                    console.error(e)
                    this.$generate_toast(
                        this,
                        'error',
                        `${this.$t('fields.item')} no ${this.$t('basic.added')} ${this.$t('basic.correctly')}`
                    )
                })
            }            
        },
        _createUpdateItemMassive(){
            this.isSubmitting = true;
            this.createItemMassive({ 
                                        store_id: this.activeStore._id, 
                                        items: this.previewDataTable.items.map(item => {
                                                const { state, old_value, ...rest } = item;
                                                return rest;
                                            }) 
                                    }).then((resp) => {
                    this.isSubmitting = false;
                    this.$generate_toast(
                        this,
                        'success',
                        `${this.$t('fields.item')} ${this.$t('basic.added')} ${this.$t('basic.correctly')}`
                        )
                    this.closeModal('true'); 
                }).catch(e => {
                    this.isSubmitting = false;
                    console.error(e)
                    this.$generate_toast(
                        this,
                        'error',
                        `${this.$t('fields.item')} no ${this.$t('basic.added')} ${this.$t('basic.correctly')}`
                    )
                })         
        },
        rowClass(item, type) {
            if (!item || type !== 'row') return
            if ((this.selectedItem && item.ean === this.selectedItem.ean) && item.is_active === false) return 'b-table-row-selected table-danger'
            if ((this.selectedItem && item.ean === this.selectedItem.ean) || item.to_assign) return 'b-table-row-selected table-blue'
            if ((this.selectedItem && item.ean === this.selectedItem.ean) || item.is_active) return 'b-table-row-selected table-warning'
        },
        onRowSelected(item) {
            this.filtered_items.forEach(x => { x.to_assign = false; if (x.is_active === false) x.is_active = true  })
            if (item && item.length > 0 && item[0].ean){
                this.selectedItem = item[0]
                this.newTag.item_id = item[0].ean
                if(item[0].is_active){
                    item[0].is_active = false
                } else if(item[0].is_active === false){
                    item[0].is_active = true
                } else {
                    item[0].to_assign = true
                }
            } else {
                this.selectedItem = {}
                this.newItem = this.activeItem;
            }
        },
        async submitFormCreate() {
            this.createModalShow = false;
            const isValid = await this.$refs.observerCreate.validate();
            const errors = Object.values(this.$refs.observerCreate.errors).flat();
            if (!isValid) {
                this.$generate_noty('warn', this.$t('forms.form_errors', {'errors':errors.length}), this.$t('alerts.error'),  5000, true)
                return
            }
            this.createModalShow = true;
        },
        compareValues(field1, field2){
            const onlyNumbers = /^\d+(\.\d+)?$/
            if (typeof field1 === 'number' || typeof field2 === 'number' || onlyNumbers.test(field1) || onlyNumbers.test(field2)){
                field1 = parseFloat(field1 || 0)
                field2 = parseFloat(field2 || 0)
            } else if(typeof field1 === 'string' || typeof field2 === 'string'){
                field1 = field1 !== null ? field1.trim().replace(/^"(.*)"$/, '$1') : ''
                field2 = field2 !== null ? field2.trim().replace(/^"(.*)"$/, '$1') : ''
            }
            // if (field1 !== field2){
            //     console.log("diff:", field1, field2)
            // }
            return (field1 !== field2)
        },
        handleFileChange(event){
            const file = event.target.files[0];
            let this_ = this
            this.previewDataTable = {}
            if (file.type === 'text/csv' || file.type === 'text/plain') {
                const reader = new FileReader();
                reader.onload =  () => {
                    this_.previewData = reader.result.split('\n');
                    // titles:
                    const validTitles = this_.fields.filter(x => x.validations.required === true).map((x) => x.key);
                    const areValidTitlesPresent = validTitles.every((validTitle) =>
                        new RegExp(`"${validTitle}"|${validTitle}`).test(this_.previewData[0])
                    );
                    if (areValidTitlesPresent){
                        this_.getItems().then(async () => {
                            this_.previewDataTable.file = { name: file.name, size: Math.round(file.size/1024) } 
                            this_.previewDataTable.fields = this_.previewData[0].split(',').map( (x) => ({ key: x, label: this_.$t('fields.'+x)}))
                            this_.previewDataTable.fields.push({ key: 'state', label: this_.$t('basic.state') })
                            this_.previewDataTable.items = await Promise.all( 
                                                    await this_.previewData.slice(1).map(async (line) => { 
                                                        const values = line.split(',')
                                                        const item = {};
                                                        let item_found = {};
                                                        for (const [index, title] of this_.previewDataTable.fields.entries()) {
                                                            if (title.key === 'state'){ 
                                                                item['state'] = false
                                                                item_found = this_.items.find( x => x.ean === item['ean'])
                                                                if (item_found && Object.keys(item_found).length > 0){
                                                                    item['state'] = true
                                                                }
                                                            } else {
                                                                item[title.key] = values[index].trim().replace(/^"(.*)"$/, '$1');
                                                            }
                                                        }
                                                        if (item['state']){
                                                            item['state'] = [];
                                                            item['old_value'] = {};
                                                            for (const [key, value] of Object.entries(item_found)) {
                                                                if(Object(item).hasOwnProperty(key) && this_.compareValues(item[key] || null, item_found[key] || null)){
                                                                    item['state'].push(key)
                                                                    item['old_value'][key] = item_found[key]
                                                                }
                                                            }
                                                        }
                                                        
                                                        return item;
                                                    })
                                                )
                            this_.randomId = Math.random()
                        });
                    } else {
                        this_.previewDataTable = {}
                        this_.randomId = Math.random()
                        this_.previewData = this_.$t('management.items.required_fields', { fields: validTitles.join(', ') })
                    }
                    this_.randomId = Math.random()
                };
                this_.previewData = reader.readAsText(file);
            } else {
                this_.previewData = this_.$t('management.items.no_valid_structure_file')
            }
        }
    },
    mounted(){
        this.newTag = _.cloneDeep(this.selectedTag)
        this.refreshTable()
        this.randomId = Math.random()
        if(this.activeItem && Object.keys(this.activeItem).length > 0){
            this.newItem = this.activeItem;
            this.fields.find(x => x.key === 'labels').options =  this.availableTags.concat(this.newItem.labels)
            this.newItem.labels = this.newItem.labels.map(x => ({id: x._id, text: x.id }))
        }
    },
}
</script>



<template>
    <div v-if="action === 'itemsModal'">
        <b-modal 
            v-model="isModalVisible" size="lg" 
            :title="`${$t('management.items.item_assign')} - Label: ${newTag.id}`" 
            @hide="closeModal('cancel')"
            @ok="assignModalShow = true"
            >
            <i class="fad fa-filter"></i> Filters: 
            <b-button-group class="mb-1 ml-1" size="sm">
                <b-button class="bg-secondary" @click="filterUnassignedItems()">{{ $t('basic.unassigned') }}</b-button>
                <b-button class="bg-secondary" @click="filterAssignedItems()">{{ $t('basic.assigned') }}</b-button>
                <b-button class="bg-secondary" @click="filterAllItems()">{{ $t('basic.all') }}</b-button>
            </b-button-group>
            <br>
            <localDatatable
                ref="itemsTable"
                :items="filtered_items" 
                :tableheaders="fields"
                :tbody-tr-class="rowClass"
                :busy.sync="isSubmitting"
                responsiveTable
                selectableTable
                selectMode="single"
                :rowSelected="onRowSelected"
                tableClass="table-striped"
            >
                <template #cell(ean)="data">
                    {{ data.value }}
                    <template v-if="data.item.is_active">
                        <span class="badge bg-primary">&check; Actual</span>
                    </template>
                    <template v-else-if="data.item.is_active === false">
                        <span class="badge bg-danger">&check; {{ $t('basic.remove') }}</span>
                    </template>
                    <template v-else-if="data.item.to_assign">
                        <span class="badge bg-blue">&check; {{ $t('basic.assign') }}</span>
                    </template>
                </template>
                <template #cell(labels)="data" >
                    {{ data.value.length }}
                </template>
                <!-- <template #cell(actions)="" >
                    <b-button @click="_assignItem(data.item)">Asignar</b-button>
                </template> -->
            </localDatatable>
            <template v-slot:modal-footer="{ cancel }">
                <b-button size="sm" variant="secondary" @click="cancel">
                {{ $t("basic.cancel") }}
                </b-button>
                <b-button size="sm" variant="primary" :disabled="isSubmitting || Object.keys(selectedItem).length === 0" @click="assignModalShow = true">
                <span v-if="!isSubmitting">
                    {{ $t("basic.assign") }}
                </span>
                <b-spinner v-if="isSubmitting" small label="Spinning" variant="light">
                </b-spinner>
                </b-button>
            </template>
        </b-modal>
        <b-modal
            id="assign-modal"
            v-model="assignModalShow"
            :title="$t('basic.assign') + ' ' + newTag.id"
            :ok-title="$t('basic.assign')"
            ok-variant="primary"
            @hidden="() => assignModalShow = false"
            @ok="_assignItem"
            >
            <p v-if="selectedItem.is_active === false">
                {{ $t('management.items.are_you_sure2')}} <b>{{ newTag.id }}</b> ?
            </p>
            <p v-else-if="Object.keys(selectedItem).length > 0">
                {{ $t('management.items.are_you_sure')}} <b>{{ newTag.id }}</b> ?
                <br>
                <br>
                EAN: <b>{{ selectedItem.ean }}</b><br>
                {{ $t("fields.description1") }}: <b>{{ selectedItem.description1 }}</b><br>
                {{ $t("fields.price1") }}: <b>${{ selectedItem.price1 }}</b>
            </p>
            
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button size="sm" variant="secondary" @click="cancel">
                {{ $t("basic.cancel") }}
                </b-button>
                <b-button size="sm" variant="danger" :disabled="isSubmitting" @click="ok">
                <span v-if="!isSubmitting">
                    {{ $t("basic.accept") }}
                </span>
                <b-spinner v-if="isSubmitting" small label="Spinning" variant="light">
                </b-spinner>
                </b-button>
            </template>
        </b-modal>
    </div>
    <div v-else-if="action === 'itemsModalCreate' || action === 'itemsModalEdit'">
        <b-modal 
            v-model="isModalVisible" size="sm" 
            :title="`Tienda: ${activeStore && activeStore.name || ''} - AP: ${activeAccessPoint && activeAccessPoint.id || 'N/A'}`" 
            @hide="closeModal('cancel')"
            @show="action === 'itemsModalCreate' ? clearItem() : () => {}"
            @ok="assignModalShow = true"
            hide-footer
            >
            <ValidationObserver ref="observerCreate" @submit.prevent="submitFormCreate">
                <b-form ref="createForm" >
                    <b-row>
                        <b-col md="12">
                            <h4>{{ newItem._id ? $t('basic.edit') : $t('basic.add') }} Producto</h4>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col v-for="item in fields" :key="item.key" :md="item.size" >
                            {{ $t(item.label) }}:
                            <ValidationProvider 
                                v-slot="validationContext"
                                :name="item.key+'|'+randomId"
                                :rules="item.validations">
                                <b-form-input v-if="item.type === 'text' || item.type === 'number'" v-model="newItem[item.key]" :type="item.type" :name="item.key+'|'+randomId" :placeholder="$t(item.label)" />
                                <Multiselect
                                    v-else-if="item.type === 'select' || item.type === 'multiselect'"
                                    v-model="newItem[item.key]"
                                    :multiple="item.type === 'multiselect' ? true : false"
                                    :name="item.key+'|'+randomId" 
                                    :options="item.options.map(x => ({id: x._id, text: x.id }))"
                                    label="text"
                                    track-by="id"
                                    :loading="isSubmitting"
                                    :internal-search="true"
                                    select-label="✚"
                                    selected-label="✓"
                                    deselect-label="✖"
                                    :showNoResults="true"
                                    :showNoOptions="true"
                                    :placeholder="$t('multiselect.placeholder', {field: $t(item.label) })"
                                    >
                                    <span slot="noOptions">{{ $t('multiselect.no_options') }}</span>
                                    <span slot="noResult">{{ $t('multiselect.no_result') }}</span>
                                </Multiselect>
                                <b-form-invalid-feedback :state="validationContext.errors.length === 0">
                                    {{ validationContext.errors.join('. ') }}
                                </b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <b-card-footer class="bg-transparent p-0 mt-3">
                        <b-button size="sm" variant="secondary" @click="closeModal">
                            {{ $t("basic.cancel") }}
                        </b-button>
                        <b-button type="submit" size="sm" variant="primary" :disabled="isSubmitting" class="ml-1">
                            <span v-if="!isSubmitting">
                                {{ newItem._id ? $t('basic.edit') : $t('basic.add') }}
                            </span>
                            <b-spinner v-if="isSubmitting" small label="Spinning" variant="light"></b-spinner>
                        </b-button>
                    </b-card-footer>
                </b-form>
            </ValidationObserver>
        </b-modal>
        <b-modal
            id="create-modal"
            v-model="createModalShow"
            :title="(newItem._id ? $t('basic.edit') : $t('basic.create')) + ' ' + $t('fields.item') + ' '+ (newItem && newItem.ean)"
            :ok-title="$t('basic.create')"
            ok-variant="primary"
            @hidden="() => createModalShow = false"
            @ok="_createUpdateItem()"
            >
            <p v-if="newItem && newItem.ean">
                Está seguro de {{ newItem._id ? _.lowerCase($t('basic.edit')) : _.lowerCase($t('basic.add')) }} el siguiente producto en la tienda <b>{{ activeStore.name }}</b> ?
                <br>
                <br>
                <table cellpadding="2">
                    <tr v-for="item in fields" :key="item.key">
                        <td>{{ $t(item.label) }}</td><td><b>{{ (typeof newItem[item.key] === 'object' && newItem[item.key] ? newItem[item.key].map(x => x.text).join(',') : newItem[item.key]) || '&lt;vacío&gt;'}}</b></td>
                    </tr>
                </table>
            </p>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button size="sm" variant="secondary" @click="cancel">
                {{ $t("basic.cancel") }}
                </b-button>
                <b-button size="sm" variant="danger" :disabled="isSubmitting" @click="ok">
                <span v-if="!isSubmitting">
                    {{ $t("basic.accept") }}
                </span>
                <b-spinner v-if="isSubmitting" small label="Spinning" variant="light">
                </b-spinner>
                </b-button>
            </template>
        </b-modal>
    </div>
    <div v-else-if="action === 'itemsMassiveModalCreate'">
        <b-modal 
            v-model="isModalVisible" size="sm" 
            :title="`Tienda: ${activeStore && activeStore.name || ''}`" 
            @hide="closeModal('cancel')"
            @ok="assignModalShow = true"
            hide-footer
            >
            <ValidationObserver ref="observerCreate" @submit.prevent="submitFormCreate">
                <b-form ref="createForm" >
                    <b-row>
                        <b-col md="12">
                            <h4>{{ $t('basic.add') }} {{ _.toLower($t('fields.items')) }} {{ $t('basic.by') }} {{ _.toLower($t('basic.file')) }}</h4>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col >
                            <ValidationProvider 
                                v-slot="validationContext"
                                :name="'file|'+randomId"
                                :rules="{'required': true, 'size': 2048, 'ext': ['csv','txt','json'] }">
                                <b-form-file
                                    v-model="uploadFile"
                                    ref="uploadFile"
                                    :name="'file|'+randomId"
                                    :state="Boolean(uploadFile)"
                                    accept=".csv, .txt, .json"
                                    :browse-text="$t('basic.browse')"
                                    :placeholder="$t('basic.uploadFile')"
                                    :drop-placeholder="$t('basic.dropFile')"
                                    @change="handleFileChange"
                                />
                                <b-form-invalid-feedback :state="validationContext.errors.length === 0">
                                    {{ validationContext.errors.join('. ') }}
                                </b-form-invalid-feedback>
                            </ValidationProvider>
                            <span v-if="Object.keys(previewDataTable).length > 0" class="text-success" :data-key="randomId">
                                {{ $tc('management.items.loaded_items', previewDataTable.items.length, { total: previewDataTable.items.length }) }}
                            </span>
                        </b-col>
                    </b-row>
                    <b-card-footer class="bg-transparent p-0 mt-3">
                        <b-button size="sm" variant="secondary" @click="closeModal">
                            {{ $t("basic.cancel") }}
                        </b-button>
                        <b-button type="submit" size="sm" variant="primary" :disabled="isSubmitting" class="ml-1">
                            <span v-if="!isSubmitting">
                                {{ $t('basic.add') }}
                            </span>
                            <b-spinner v-if="isSubmitting" small label="Spinning" variant="light"></b-spinner>
                        </b-button>
                    </b-card-footer>
                </b-form>
            </ValidationObserver>
        </b-modal>
        <b-modal
            id="create-modal"
            v-model="createModalShow"
            size="xl"
            :title="_.capitalize(`${$t('basic.add')} ${$t('fields.item')} ${$t('basic.by')}  ${$t('basic.file')}`)"
            :ok-title="$t('basic.create')"
            ok-variant="primary"
            @hidden="() => createModalShow = false"
            @ok="_createUpdateItemMassive()"
            >
            <p v-if="uploadFile && Object.keys(previewDataTable).length > 0">
                <span class="text-info">{{  previewDataTable.file.name }} - {{ previewDataTable.file.size }}KB</span><br>
                {{ $t('basic.preview')}} ({{ previewDataTable.items.length }} {{ $t('fields.items') }}):
                <br>
                <b-table 
                    responsive hover small bordered
                    class="font-11 bg-white"
                    head-variant="dark"
                    :items="previewDataTable.items" 
                    :fields="previewDataTable.fields" 
                >
                    <template #cell()="data">
                        <span v-if="typeof data.item.state === 'object' && data.item.state.includes(data.field.key)" 
                            class="text-decoration-line-through text-danger">
                            {{ data.item.old_value[data.field.key] }}
                            <span :class="{ 'text-blue' : data.item['old_value'] && (data.item.old_value[data.field.key] == '' || data.item.old_value[data.field.key] == 0) }">
                            {{ data.value }}
                            <span v-if="data.item.old_value[data.field.key] && (data.value === '' || !data.value)" class="text-blue">
                                &lt;{{ $t('basic.deleted') }}&gt;
                            </span>
                        </span>
                        </span>
                        <span v-else >
                            {{ data.value }}
                        </span>
                    </template>
                    <template #cell(state)="data">
                        <b-badge pill :class="{ 'bg-success' : data.value, 'bg-info' : !data.value }" class="p-1">
                            {{ data.value ? $t('basic.update') : $t('basic.add') }}
                        </b-badge>
                    </template>
                </b-table>
                <b>{{ $tc('management.items.are_you_sure_massive', previewDataTable.items.length, { number: previewDataTable.items.length })}}</b>
            </p>
            <p v-else class="text-danger">
                {{ previewData }}
            </p>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button size="sm" variant="secondary" @click="cancel">
                {{ $t("basic.cancel") }}
                </b-button>
                <b-button size="sm" variant="danger" :disabled="isSubmitting" @click="ok">
                <span v-if="!isSubmitting">
                    {{ $t("basic.accept") }}
                </span>
                <b-spinner v-if="isSubmitting" small label="Spinning" variant="light">
                </b-spinner>
                </b-button>
            </template>
        </b-modal>
    </div>
</template>
<style lang="scss">
.font-11 {
    font-size: 11px !important;
}
.text-decoration-line-through {
    text-decoration: line-through;
}
</style>